module.exports = __webpack_public_path__ + "hbomaxar-static/media/selena-chef.64e060d6.mp4";